import httpClient from '@/lib/httpClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

/** Deletes a vault group; its vaults move back to the top level. */
export default function useDeleteVaultGroup() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ({ id }: { id: string | number }) =>
      httpClient.delete(`team/vault/group/${id}`),
    onSuccess: () => {
      toast.success('Group deleted')
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
    },
    onError: (error: any) =>
      toast.error(error?.response?.data?.message ?? 'An error occurred.'),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
